import { Eleve } from 'types/eleves';
import { LivretEval } from '../types/livret';
import { getLSUStatus } from './getLSUStatus';
import { EleveBasicInfo } from './types';

export function buildElevesBasicInfos(
  eleves: Eleve[],
  livretEval: LivretEval,
): EleveBasicInfo[] {
  return eleves
    .filter(ev => ev.classroomId === livretEval.classroomId)
    .map(eleve => {
      const matchingLivretEleve = livretEval.livretsEleves.find(
        livretEleve => livretEleve.eleveId === eleve.id,
      );
      return {
        id: eleve?.id,
        picture: eleve?.picture,
        familyName: eleve?.familyName,
        givenName: eleve?.givenName,
        statusLsu: getLSUStatus(matchingLivretEleve),
        status: matchingLivretEleve?.status,
      };
    });
}
